export default {
  hero: {
    "are-you-a-supplier": "Je suis un fournisseur ?",
    "new-material": "Nouveau matériel",
    title: "Acheter votre matériel n'a jamais été aussi simple",
    description:
      "Demandez des devis personnalisés, accédez à des produits disponibles pour un achat immédiat, suivez vos livraisons en temps réel et profitez de notre programme d’achat groupé pour des économies garanties !",
    "try-now": "Essayer maintenant",
  },
  values: {
    object: "Fonctionnalités",
    title: "Nos services",
    description:
      "Quis tellus eget adipiscing convallis sit sit eget aliquet quis. Suspendisse eget egestas a elementum pulvinar et feugiat blandit at. In mi viverra elit nunc.",
    features: {
      quote: {
        title: "Demande de devis auprès des fournisseurs",
        description:
          "Simplifiez le processus de demande de devis en envoyant directement vos besoins à plusieurs fournisseurs et obtenez des propositions adaptées à votre projet.",
      },
      buying: {
        title: "Accès à des produits pour achat immédiat :",
        description:
          "Explorez une sélection de produits disponibles à l'achat immédiat, sans attente ni formalités, pour répondre rapidement à vos besoins en matériel.",
      },
      delivery: {
        title: "Suivi des livraisons",
        description:
          "Gardez un œil en temps réel sur l'état de vos commandes et suivez chaque étape de la livraison jusqu'à la réception de votre matériel.",
      },
      "group-buying": {
        title: "Programme d'achat groupé",
        description:
          "Profitez de réductions avantageuses en rejoignant notre programme d'achat groupé, permettant de réaliser des économies substantielles sur vos commandes grâce à des achats en volume.",
      },
      integration: {
        title: "Intégration facile du matériel de vos projets",
        description:
          "Facilitez l'intégration de votre nouveau matériel dans vos projets avec des solutions conçues pour une adaptation rapide et sans effort à vos systèmes existants.",
      },
      historic: {
        title: "Historique des commandes",
        description:
          "Accédez à un historique complet de vos commandes passées pour suivre vos achats et gérer vos stocks plus efficacement.",
      },
    },
  },
  reservations: {
    title: "Les Avantages de l’Achat Groupé de Matériel Photovoltaïque",
    description:
      "L'achat groupé de matériel photovoltaïque est une pratique de plus en plus prisée pour ses nombreux avantages. En regroupant les commandes, cette méthode permet non seulement de réaliser des économies substantielles, mais aussi de simplifier le processus d'achat pour tous les participants.",
    advantages: {
      title:
        "Voici pourquoi cette approche est avantageuse et comment elle fonctionne en trois étapes simples.",
      price: {
        title: "Réduction des Coûts",
        description:
          "L'achat groupé permet de réduire considérablement les coûts en négociant des tarifs préférentiels grâce à des commandes combinées. Cela rend les équipements photovoltaïques plus abordables pour les participants.",
      },
      quality: {
        title: "Accès à des Produits de Qualité",
        description:
          "L'achat groupé offre des produits de haute qualité à prix réduits. Les fournisseurs privilégient les commandes groupées en proposant des équipements fiables et performants.",
      },
      simplicity: {
        title: "Simplification du Processus d'Achat",
        description:
          "L'achat groupé simplifie la gestion en centralisant les commandes et réduisant les transactions individuelles. Cela facilite le suivi et la réception du matériel pour les participants.",
      },
      conclusion:
        "En conclusion, l'achat groupé de matériel photovoltaïque est une solution avantageuse qui permet de réaliser des économies importantes tout en simplifiant le processus d'acquisition. En suivant les trois étapes clés de participation, paiement, et suivi, vous pouvez bénéficier des meilleurs tarifs tout en assurant une gestion efficace de votre achat.",
    },
  },
  checkout: {
    title: "Catalogue de +10000 modèles",
    "see-more": "Voir toute la sélection",
    database: "Base de donnée",
  },
  simplicity: {
    object: "Optimisation",
    title: "Intégration facile du matériel prévu dans vos projets",
    paragraph1:
      "Notre solution facilite l'intégration du matériel prévu dans vos projets dès la phase de planification. Vous pouvez attribuer le matériel à différents projets ou devis de vos clients même avant sa réception.",
    paragraph2:
      "Grâce à notre interface intuitive, vous gérez facilement l'affectation du matériel aux projets en cours, ce qui simplifie la préparation et l'organisation de vos projets.",
    paragraph3:
      "Cette flexibilité permet une meilleure gestion des ressources et une planification plus efficace, tout en assurant que chaque projet dispose des équipements nécessaires dès que les besoins sont définis.",
    "try-now": "Essayez maintenant",
  },
  logistics: {
    object: "Livraison",
    title: "Suivi de vos livraisons en temps réel",
    description:
      "Notre service de suivi vous permet de surveiller vos livraisons de matériel photovoltaïque en temps réel. Grâce à notre système de traçabilité avancé, vous recevez des mises à jour instantanées sur l'état de votre commande, depuis l'expédition jusqu'à la livraison finale. Vous pouvez consulter l'emplacement actuel de votre matériel, prévoir les délais de réception, et être informé de toute éventuelle modification ou retard. Ce suivi transparent et précis vous offre une tranquillité d'esprit, vous permettant de mieux planifier l'installation de vos équipements photovoltaïques et d’assurer une gestion efficace de votre projet.",
    timeline: {
      step1: "Préparation et emballage du matériel pour l'expédition.",
      step2: "Expédition du matériel par l'expéditeur.",
      step3: "Transport du matériel vers le centre de distribution.",
      step4: "Traitement du matériel au centre de distribution.",
      step5: "Livraison du matériel à l'adresse de destination.",
      step6: "Confirmation de réception.",
    },
  },
  "data-driven": {
    "down-stream-sales-title": "Visibilité pour vos ventes en aval",
    "down-stream-sales-desc":
      "Notre solution facilite l'intégration du matériel prévu dans vos projets dès la phase de planification. Vous pouvez attribuer le matériel à différents projets ou devis de vos clients même avant sa réception. Grâce à notre interface intuitive, vous gérez facilement l'affectation du matériel aux projets en cours, ce qui simplifie la préparation et l'organisation de vos projets. Cette flexibilité permet une meilleure gestion des ressources et une planification plus efficace, tout en assurant que chaque projet dispose des équipements nécessaires dès que les besoins sont définis.",
    "purchase-suggestion-title": "Suggestion d'achat",
    "purchase-suggestion-desc":
      "Notre solution facilite l'intégration du matériel prévu dans vos projets dès la phase de planification. Vous pouvez attribuer le matériel à différents projets ou devis de vos clients même avant sa réception. Grâce à notre interface intuitive, vous gérez facilement l'affectation du matériel aux projets en cours, ce qui simplifie la préparation et l'organisation de vos projets. Cette flexibilité permet une meilleure gestion des ressources et une planification plus efficace, tout en assurant que chaque projet dispose des équipements nécessaires dès que les besoins sont définis.",
    "human-in-loop-title": "Humain dans la boucle",
    "human-in-loop-desc":
      "Notre solution facilite l'intégration du matériel prévu dans vos projets dès la phase de planification. Vous pouvez attribuer le matériel à différents projets ou devis de vos clients même avant sa réception. Grâce à notre interface intuitive, vous gérez facilement l'affectation du matériel aux projets en cours, ce qui simplifie la préparation et l'organisation de vos projets. Cette flexibilité permet une meilleure gestion des ressources et une planification plus efficace, tout en assurant que chaque projet dispose des équipements nécessaires dès que les besoins sont définis.",
    "data-driven": "Piloté par les données",
    "coming-soon": "Bientôt disponible",
  }
}
